import { lazy, Suspense } from "react";
import type { RouteObject } from "react-router";
import { ErrorRouteBoundary } from "@/src/common/components/error-route-boundary";
import { RouteFallback } from "@/src/common/components/route-fallback";

const OAuthAuthorizePage = lazy(() => import("@/src/oauth/pages/oauth-authorize-page"));

export const oauthRoutes: RouteObject = {
	path: "/oauth/authorize",
	errorElement: <ErrorRouteBoundary />,
	element: (
		<Suspense fallback={<RouteFallback />}>
			<OAuthAuthorizePage />
		</Suspense>
	),
};
